import { Alert, AlertTitle, Box } from '@mui/material';
import { getRejectionReason, isRejectedTemplate } from '../../utils/getRejectionReason';

export default function TemplateRejectionAlert({ template, sx }) {
  if (!isRejectedTemplate(template)) return null;

  const reason = getRejectionReason(template);
  if (!reason) return null;

  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Alert severity="error" variant="outlined">
        <AlertTitle sx={{ fontWeight: 700, fontSize: '0.875rem' }}>Template Rejected</AlertTitle>
        {reason}
      </Alert>
    </Box>
  );
}
